import React from 'react'
import '../../index.css'

const IconTitle = ({title, onImageClick, img, active}) => {
    const onKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onImageClick()
        }
    }

    return (
        <>
            <div
                className={`icons-title${active ? ' active' : ''}`}
                onClick={onImageClick}
                onKeyDown={onKeyDown}
                role="button"
                tabIndex={0}
                aria-pressed={!!active}
            >
                <img className="icons" src={img} alt="" />
                <h4 className="service-title">{title}</h4>
            </div>
        </>
    )
}

export default IconTitle
